import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectQuestionList = createSelector(
  [(store: RootState) => store.templateDetail.questionList],
  (list) => list
);
